<div class="info-card">
    @if (title()) {
        <div class="info-card__header">
            @if (icon()) {
                <i [class]="icon() + ' info-card__header-icon'"></i>
            }
            <h6 class="info-card__title">{{ title() }}</h6>
        </div>
    }
    <div class="info-card__body">
        <ng-content></ng-content>
    </div>
</div>
